import styled from 'styled-components';

const Icon = styled.div`
  position: absolute;
  width: 16px;
  height: 24px;
  top: 50%;
  margin-top: -12px;
  margin-left: -8px;
  background-image: url("assets/images/timeRangePickerHandle.png");
  background-size: 100%;
  cursor: -webkit-grab;
`;

export { Icon };
